import { render, staticRenderFns } from "./PersonAlarmList.vue?vue&type=template&id=f413a31a&scoped=true"
import script from "./PersonAlarmList.vue?vue&type=script&lang=js"
export * from "./PersonAlarmList.vue?vue&type=script&lang=js"
import style0 from "./PersonAlarmList.vue?vue&type=style&index=0&id=f413a31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f413a31a",
  null
  
)

export default component.exports